//src/Components/TopBar/ChatbotButton.tsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ChatbotButton.css';

const ChatbotButton = () => {
  useEffect(() => {
    const updateButtonLabel = () => {
      const chatbotButton = document.querySelector(
        '.chatbot-button',
      ) as HTMLButtonElement;
      if (window.innerWidth <= 768) {
        chatbotButton.textContent = 'AI';
      } else {
        chatbotButton.textContent = 'Meet AI MITO';
      }
    };

    updateButtonLabel();
    window.addEventListener('resize', updateButtonLabel);

    return () => window.removeEventListener('resize', updateButtonLabel);
  }, []);

  return (
    <div className="chatbot-button-wrapper">
      <Link to="/dashboard/ai-mito">
        <button className="chatbot-button">Meet AI MITO</button>
      </Link>
      <span className="chatbot-subtext">
        Designed to assist you with all your accounting and taxation queries
      </span>
    </div>
  );
};

export default ChatbotButton;
